import script from "./ResetPasswordView.vue?vue&type=script&setup=true&lang=js"
export * from "./ResetPasswordView.vue?vue&type=script&setup=true&lang=js"

import "./ResetPasswordView.vue?vue&type=style&index=0&id=eb146438&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-eb146438"]])

export default __exports__